module.exports = __webpack_public_path__ + "img/logo.adb1f56f.svg";